<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import "./common/style/app.css";
@import "./common/style/index.css";
@import './common/style/swiper.min.css';
</style>



// WEBPACK FOOTER //
// src/App.vue